import MetricAttributes from './MetricAttributes';
import { isAdminTenant } from '../config/TenantId';
const GlobalMetricAttributes = () => {
    const metricAttributes = MetricAttributes();
    return {
        clear(tenantId) {
            if (isAdminTenant(tenantId)) {
                metricAttributes.clear();
            }
        },
        mergeAttributes(newAttributes, tenantId) {
            if (isAdminTenant(tenantId)) {
                metricAttributes.mergeAttributes(newAttributes);
            }
        },
        toAttributes: () => metricAttributes.toAttributes(),
    };
};
export default GlobalMetricAttributes();
//# sourceMappingURL=GlobalMetricAttributes.js.map